import React from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import { DashboardPipelineStage } from '../models/dashboard.model';
import { getPipelineTotal } from '../utils/dashboard.utils';

interface Props {
  activeCandidates: number;
  openJobs: number;
  stages: DashboardPipelineStage[];
  onViewPipeline: () => void;
}

const PipelineOverview: React.FC<Props> = ({
  activeCandidates,
  openJobs,
  stages,
  onViewPipeline,
}) => {
  const visiblePipelineTotal = getPipelineTotal(stages);

  return (
    <section
      className="dashboard-panel dashboard-pipeline"
      aria-labelledby="pipeline-overview-title"
    >
      <header className="dashboard-panel__header">
        <h2 id="pipeline-overview-title">Pipeline overview</h2>
        <button
          className="dashboard-link"
          type="button"
          onClick={onViewPipeline}
        >
          Open pipeline <ArrowRightOutlined aria-hidden />
        </button>
      </header>
      <div className="dashboard-pipeline__content">
        <div className="dashboard-pipeline__total">
          <strong>{activeCandidates} candidates</strong>
          <span>Across {openJobs} open jobs</span>
        </div>
        {stages.map((stage) => (
          <div className="dashboard-pipeline__stage" key={stage.key}>
            <strong>{stage.count}</strong>
            <span>{stage.label}</span>
          </div>
        ))}
        <span className="sr-only">
          {visiblePipelineTotal} applications are represented in the displayed
          pipeline stages.
        </span>
      </div>
    </section>
  );
};

export default PipelineOverview;
